'use strict';

/**
 * Collection of validation helper functions.
 */
var validation = {};

/**
 * Verify if every argument is a valid string.
 * @returns {boolean} true if every argument is a valid string
 */
function isValidString() {
    var result = true;

    $.each(arguments, function (index, arg) {
        if (
            result &&
            (typeof arg !== 'string' || arg === '' || arg === 'null' || arg === 'undefined' || arg === null || arg === undefined)
        ) {
            result = false;
        }
    });

    return result;
}

/**
 * Expose functions
 */
validation.isValidString = isValidString;

module.exports = validation;
